<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li class="currentNode"><a>项目展示</a></li>
            </ul>
            <div class="page-main">
                <h3>项目展示</h3>
                <el-table
                    class="theadTable"
                    :data="tableData"
                    stripe>
                        <el-table-column
                            label="项目名称"
                            width="400">
                            <template slot-scope="scope">
                                <p class="ellipsis_one projectTitle" @click="goDetail(scope.row)">{{ scope.row.Title }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="投资额"
                            width="100">
                            <template slot-scope="scope">
                                <p class="projectPrice">{{ scope.row.SubTitle }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="项目内容"
                            width="720">
                            <template slot-scope="scope">
                                <p class="ellipsis_two projectContent">{{ scope.row.Content }}</p>
                            </template>
                        </el-table-column>

                    </el-table>
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    @current-change="handleCurrentChange">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getProjectShow
} from '@services/indexService.js';

export default {
    name: '',
    data() {
        return {
            total: 0,
            currentPage: 1,
            pageSize: 12,
            tableData: [],
        };
    },
    created() {
        if (this.$route.query.page) {
            this.currentPage = Number(this.$route.query.page);
        }
        this.getProjectShow();
    },
    methods: {
        getProjectShow() {
            let params = {
                current: this.currentPage,
                size: this.pageSize,
            };
            getProjectShow(params).then(res => {
                if (res.Code == 1) {
                    this.tableData = res.Data;
                    this.total = res.Count;
                } else {
                    this.$message.error("医疗科普请求失败");
                }
            })
        },
        handleCurrentChange(pageNum) {
            this.currentPage = pageNum;
            this.getMedical();
        },
        goDetail(data) {
            let newUrl = this.$router.resolve({
                path:'/layout/project-detail',
                query: {
                    id: data.Id,
                    page: this.currentPage
                }
            });
            window.open(newUrl.href, '_blank');
        }
    },
};
</script>

<style scoped>
.page-main {
    display: block;
    background: #fff;
    padding: 30px 30px;
    box-sizing: border-box;
}
.page-main h3 {
    color: #262626;
    font-size: 22px;
    text-align: center;
    margin-bottom: 30px;
}
.theadTable {
    box-shadow: -2px -2px 16px 1px #00000026;
    margin-bottom: 30px;
}
.projectTitle {
    color: #262626;
    font-size: 18px;
    cursor: pointer;
}
.projectTitle:hover {
    color: #116EBA;
}
.projectPrice {
    color: #116EBA;
    font-size: 14px;
}
.projectContent {
    color: #6A6A6A;
    font-size: 14px;
}
</style>